import { Inject, Injectable, Injector }from '@angular/core';


import { FootprintEdi_ds_check_serial_numbersService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_find_addressService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_find_orders_for_revisionsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_adjustment_taskIdsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_average_weight_by_materialService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_completed_shipments_without_transmissionsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_dock_appointments_itemsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_materials_for_validationService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_measurement_unitsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_orders_for_revisionsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_packagings_by_materialService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_shipments_by_orderIdService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_status_change_move_taskIdsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_wavelength_order_transmissionsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_wavelength_shipment_transmissionsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_get_wavelength_task_transmissionsService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_materials_lookup_code_ddService } from './FootprintEdi.datasource.index';
import { FootprintEdi_ds_uom_gridService } from './FootprintEdi.datasource.index';

@Injectable({ providedIn: 'root' })
export class FootprintEdi_DatasourceService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootprintEdi: FootprintEdi_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_check_serial_numbers: FootprintEdi_ds_check_serial_numbersService;
  public get ds_check_serial_numbers(): FootprintEdi_ds_check_serial_numbersService {
    if(!this._ds_check_serial_numbers) {
      this._ds_check_serial_numbers = this.injector.get(FootprintEdi_ds_check_serial_numbersService);
    }
    return this._ds_check_serial_numbers;
  }
  private _ds_find_address: FootprintEdi_ds_find_addressService;
  public get ds_find_address(): FootprintEdi_ds_find_addressService {
    if(!this._ds_find_address) {
      this._ds_find_address = this.injector.get(FootprintEdi_ds_find_addressService);
    }
    return this._ds_find_address;
  }
  private _ds_find_orders_for_revisions: FootprintEdi_ds_find_orders_for_revisionsService;
  public get ds_find_orders_for_revisions(): FootprintEdi_ds_find_orders_for_revisionsService {
    if(!this._ds_find_orders_for_revisions) {
      this._ds_find_orders_for_revisions = this.injector.get(FootprintEdi_ds_find_orders_for_revisionsService);
    }
    return this._ds_find_orders_for_revisions;
  }
  private _ds_get_adjustment_taskIds: FootprintEdi_ds_get_adjustment_taskIdsService;
  public get ds_get_adjustment_taskIds(): FootprintEdi_ds_get_adjustment_taskIdsService {
    if(!this._ds_get_adjustment_taskIds) {
      this._ds_get_adjustment_taskIds = this.injector.get(FootprintEdi_ds_get_adjustment_taskIdsService);
    }
    return this._ds_get_adjustment_taskIds;
  }
  private _ds_get_average_weight_by_material: FootprintEdi_ds_get_average_weight_by_materialService;
  public get ds_get_average_weight_by_material(): FootprintEdi_ds_get_average_weight_by_materialService {
    if(!this._ds_get_average_weight_by_material) {
      this._ds_get_average_weight_by_material = this.injector.get(FootprintEdi_ds_get_average_weight_by_materialService);
    }
    return this._ds_get_average_weight_by_material;
  }
  private _ds_get_completed_shipments_without_transmissions: FootprintEdi_ds_get_completed_shipments_without_transmissionsService;
  public get ds_get_completed_shipments_without_transmissions(): FootprintEdi_ds_get_completed_shipments_without_transmissionsService {
    if(!this._ds_get_completed_shipments_without_transmissions) {
      this._ds_get_completed_shipments_without_transmissions = this.injector.get(FootprintEdi_ds_get_completed_shipments_without_transmissionsService);
    }
    return this._ds_get_completed_shipments_without_transmissions;
  }
  private _ds_get_dock_appointments_items: FootprintEdi_ds_get_dock_appointments_itemsService;
  public get ds_get_dock_appointments_items(): FootprintEdi_ds_get_dock_appointments_itemsService {
    if(!this._ds_get_dock_appointments_items) {
      this._ds_get_dock_appointments_items = this.injector.get(FootprintEdi_ds_get_dock_appointments_itemsService);
    }
    return this._ds_get_dock_appointments_items;
  }
  private _ds_get_materials_for_validation: FootprintEdi_ds_get_materials_for_validationService;
  public get ds_get_materials_for_validation(): FootprintEdi_ds_get_materials_for_validationService {
    if(!this._ds_get_materials_for_validation) {
      this._ds_get_materials_for_validation = this.injector.get(FootprintEdi_ds_get_materials_for_validationService);
    }
    return this._ds_get_materials_for_validation;
  }
  private _ds_get_measurement_units: FootprintEdi_ds_get_measurement_unitsService;
  public get ds_get_measurement_units(): FootprintEdi_ds_get_measurement_unitsService {
    if(!this._ds_get_measurement_units) {
      this._ds_get_measurement_units = this.injector.get(FootprintEdi_ds_get_measurement_unitsService);
    }
    return this._ds_get_measurement_units;
  }
  private _ds_get_orders_for_revisions: FootprintEdi_ds_get_orders_for_revisionsService;
  public get ds_get_orders_for_revisions(): FootprintEdi_ds_get_orders_for_revisionsService {
    if(!this._ds_get_orders_for_revisions) {
      this._ds_get_orders_for_revisions = this.injector.get(FootprintEdi_ds_get_orders_for_revisionsService);
    }
    return this._ds_get_orders_for_revisions;
  }
  private _ds_get_packagings_by_material: FootprintEdi_ds_get_packagings_by_materialService;
  public get ds_get_packagings_by_material(): FootprintEdi_ds_get_packagings_by_materialService {
    if(!this._ds_get_packagings_by_material) {
      this._ds_get_packagings_by_material = this.injector.get(FootprintEdi_ds_get_packagings_by_materialService);
    }
    return this._ds_get_packagings_by_material;
  }
  private _ds_get_shipments_by_orderId: FootprintEdi_ds_get_shipments_by_orderIdService;
  public get ds_get_shipments_by_orderId(): FootprintEdi_ds_get_shipments_by_orderIdService {
    if(!this._ds_get_shipments_by_orderId) {
      this._ds_get_shipments_by_orderId = this.injector.get(FootprintEdi_ds_get_shipments_by_orderIdService);
    }
    return this._ds_get_shipments_by_orderId;
  }
  private _ds_get_status_change_move_taskIds: FootprintEdi_ds_get_status_change_move_taskIdsService;
  public get ds_get_status_change_move_taskIds(): FootprintEdi_ds_get_status_change_move_taskIdsService {
    if(!this._ds_get_status_change_move_taskIds) {
      this._ds_get_status_change_move_taskIds = this.injector.get(FootprintEdi_ds_get_status_change_move_taskIdsService);
    }
    return this._ds_get_status_change_move_taskIds;
  }
  private _ds_get_wavelength_order_transmissions: FootprintEdi_ds_get_wavelength_order_transmissionsService;
  public get ds_get_wavelength_order_transmissions(): FootprintEdi_ds_get_wavelength_order_transmissionsService {
    if(!this._ds_get_wavelength_order_transmissions) {
      this._ds_get_wavelength_order_transmissions = this.injector.get(FootprintEdi_ds_get_wavelength_order_transmissionsService);
    }
    return this._ds_get_wavelength_order_transmissions;
  }
  private _ds_get_wavelength_shipment_transmissions: FootprintEdi_ds_get_wavelength_shipment_transmissionsService;
  public get ds_get_wavelength_shipment_transmissions(): FootprintEdi_ds_get_wavelength_shipment_transmissionsService {
    if(!this._ds_get_wavelength_shipment_transmissions) {
      this._ds_get_wavelength_shipment_transmissions = this.injector.get(FootprintEdi_ds_get_wavelength_shipment_transmissionsService);
    }
    return this._ds_get_wavelength_shipment_transmissions;
  }
  private _ds_get_wavelength_task_transmissions: FootprintEdi_ds_get_wavelength_task_transmissionsService;
  public get ds_get_wavelength_task_transmissions(): FootprintEdi_ds_get_wavelength_task_transmissionsService {
    if(!this._ds_get_wavelength_task_transmissions) {
      this._ds_get_wavelength_task_transmissions = this.injector.get(FootprintEdi_ds_get_wavelength_task_transmissionsService);
    }
    return this._ds_get_wavelength_task_transmissions;
  }
  private _ds_materials_lookup_code_dd: FootprintEdi_ds_materials_lookup_code_ddService;
  public get ds_materials_lookup_code_dd(): FootprintEdi_ds_materials_lookup_code_ddService {
    if(!this._ds_materials_lookup_code_dd) {
      this._ds_materials_lookup_code_dd = this.injector.get(FootprintEdi_ds_materials_lookup_code_ddService);
    }
    return this._ds_materials_lookup_code_dd;
  }
  private _ds_uom_grid: FootprintEdi_ds_uom_gridService;
  public get ds_uom_grid(): FootprintEdi_ds_uom_gridService {
    if(!this._ds_uom_grid) {
      this._ds_uom_grid = this.injector.get(FootprintEdi_ds_uom_gridService);
    }
    return this._ds_uom_grid;
  }
}

